export const getExportDataTour = () => [
  {
    target: 'body',
    title: 'Eksportér Data',
    content:
      'Eksportér Data er stedet, hvor du kan hente målt data ud fra ReCalc. Her vælger du, hvilke units du vil eksportere data fra, hvilken periode data skal dække, hvordan data skal aggregeres, og hvilke kolonner der skal med i eksporten.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="export-data-units"]',
    title: 'Vælg units til eksport',
    content:
      'Start med at vælge en eller flere units, som du vil eksportere data fra. De valgte units bestemmer, hvilket målt data der bliver inkluderet i eksporten.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="export-data-date-range"]',
    title: 'Vælg periode',
    content:
      'Her vælger du start- og slutdato for den periode, du vil eksportere data fra. Du kan enten vælge datoerne manuelt eller bruge genvejsknapperne til hurtigt at vælge de seneste 7, 14, 30 eller 90 dage.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="export-data-aggregation"]',
    title: 'Vælg aggregering',
    content:
      'Aggregering bestemmer, hvordan data samles i eksporten. Du kan for eksempel vælge at samle data pr. time, så målingerne bliver grupperet i timeintervaller.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="export-data-columns"]',
    title: 'Vælg kolonner og tilpas deres rækkefølge',
    content:
      'Her vælger du, hvilke kolonner der skal med i eksporten. Kun markerede kolonner bliver inkluderet i den endelige eksportfil. Du kan trække og slippe kolonneoverskrifter for at ændre rækkefølgen i eksporten. Kolonnerne eksporteres i den rækkefølge, de vises fra venstre mod højre.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="export-data-preview"]',
    title: 'Forhåndsvisning',
    content:
      'Tabellen viser en forhåndsvisning af, hvordan eksporten kommer til at se ud. Her kan du kontrollere timestamps, værdier, unit-oplysninger, datatyper, beskrivelser og enheder, før du eksporterer.',
    placement: 'top',
  },
  {
    target: '[data-tour="export-data-format"]',
    title: 'Vælg eksportformat',
    content:
      'Vælg om data skal eksporteres som Excel- eller CSV-fil. Excel er velegnet til videre arbejde i regneark, mens CSV er praktisk til import i andre systemer.',
    placement: 'top',
  },
  {
    target: '[data-tour="export-data-submit"]',
    title: 'Eksportér filen',
    content:
      'Når du har valgt mindst en unit og mindst en kolonne, bliver eksportknappen aktiv. Klik på eksportknappen for at hente data i det valgte format.',
    placement: 'left',
  },
];
